import { UIGameGoToPointAnimation } from './UIGameGoToPointAnimation.ts';
import { UIGameFadeAnimation } from './UIGameFadeAnimation.ts';
export class UIGameGoToPointFadeAnimation extends UIGameGoToPointAnimation {
    start() {
        this.viewToAnimate.alpha = this.options.initialAlpha;
        super.start();
        return this;
    }
    onGameTick(deltaTime, elapsedMS) {
        super.onGameTick(deltaTime, elapsedMS);
        this.fadeAnimation.updateAnimation(deltaTime, elapsedMS, this.completionPercentage);
    }
    resetToDefaultState() {
        this.fadeAnimation.resetToDefaultState();
        super.resetToDefaultState();
    }
    static getDefaultOptions() {
        return {
            initialAlpha: 1,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0.1,
            isFadeIn: false
        };
    }
    constructor(viewToAnimate, destinationPoint, speed, options){
        super(viewToAnimate, destinationPoint, speed);
        this.options = options !== null && options !== void 0 ? options : UIGameGoToPointFadeAnimation.getDefaultOptions();
        this.fadeAnimation = new UIGameFadeAnimation(viewToAnimate, undefined, this.options);
    }
}
